
 $('.btn-offer').off('click').on('click', function () {
    if ($(this).hasClass("selected")) {
        $(this).removeClass("selected")
        $(this).addClass("button-warranty")
         $("#shipping-option").remove();
         //$("#shipping-number").remove();
         console.log('remove ship option');
         cycsopth = '';
         cycsopvid = 0;
         cycsopid = 0;
         $( ".cycshipopmsg" ).html( '<strong>Stardard Shipping Includes:</strong> Inside Delivery');
        }else{
          $(".cycship_cart .selected, #cps-warranty .selected").removeClass("selected");
          $(this).addClass("selected")
          $(this).removeClass("button-warranty")
          $(".btn-warranty2").not(".selected").addClass("button-warranty")
          
          cycsopth = $(this).attr("d-handle-attr");
          cycsopid = $(this).attr("d-id-attr");
          cycsopvid = $(this).attr("d-vid-attr");
          cycsopmsg = $(this).attr("d-msg-attr");

          console.log('Add Shipping Option' + cycsopth);
          $("#shipping-option").remove();
          //$("#shipping-number").remove();
          //$( ".cyc-product-inputs" ).after( '<input id="shipping-number" type="hidden" name="properties[delivery_num]" value="'+cycrandomNumber+'">' );
          //$( ".cyc-product-inputs" ).after( '<input id="shipping-option" type="hidden" name="properties[delivery_item]" value="'+cycsopth+'">' );
          $( ".cycshipopmsg" ).html( '<strong>Shipping Now Includes:</strong> ' +  cycsopmsg);

        }
});


function cycupdatecartshipopt(){
fetch(`${routes.cart_url}?sections=cart-drawer`)
    .then((response) => response.json())
    .then((sections) => {
      const sectionIds = ['cart-drawer'];
      for (const sectionId of sectionIds) {
        const htmlString = sections[sectionId];
        const html = new DOMParser().parseFromString(htmlString, 'text/html');
        const sourceElement = html.querySelector(`${sectionId}`);
        const targetElement = document.querySelector(`${sectionId}`);
        if (targetElement && sourceElement) {
          targetElement.replaceWith(sourceElement);
        }
      }
      document.body.classList.add('overflow-hidden');
      const theme_cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (theme_cart && theme_cart.classList.contains('is-empty')) theme_cart.classList.remove('is-empty');
      theme_cart.classList.add('active');
    })
    .catch((e) => {
      console.error('Error updating cart sections:', e);
    });
  fetch('/cart.js')
  .then(response => response.json())
  .then(cart => {
    $('.cart-count-bubble').html('<span aria-hidden="true">'+ cart.item_count +'</span>');
  });

}


function cycaddshippingoption() {
        if (cycsopvid == 0) {
        return; // Exit early if cycsopvid is 0
        }

           let data = {
           quantity: 1,
            id: cycsopvid
            };
             data.properties = {};
             data.properties["Applies to"] = 'All ' + cycsopvendor + ' Items';
             data.properties["Brand"] = cycsopvendor;
             //data.properties["delivery_num"] = cycrandomNumber;

           jQuery.post('/cart/add.js',data,null,"json")
                      .done(function () {
              cycupdatecartshipopt();
              $('.btn-offer.selected').css('background-color', '#444ce7').css('color', '#FFFFFF').addClass("cycdisabled");
              var cycshipopmsg = $('.cycshipopmsg').html();
              $('.btn-offer.selected').click();
              $('.btn-offer.cycdisabled').find('.price-amt').html('Already Added');
              $('.btn-offer.cycdisabled').prop('disabled', true);
              //$( ".cyc-product-inputs" ).after( '<input id="shipping-option" type="hidden" name="properties[delivery_item]" value="'+$('.btn-offer.cycdisabled').attr("d-handle-attr")+'">' );
              $(".cycshipopmsg").html(cycshipopmsg);
           })
           .fail(function ($xhr) {
             var data = $xhr.responseJSON;
             //$('.qv-add-to-cart-response').addClass('error').html('<span><b>ERROR: </b>' + data.description);
           });

   }